<template>
  <div class="login-page">
    <section class="login-hero">
      <div class="login-hero__inner">
        <div class="login-brand">
          <span class="brand-mark brand-mark--lg" aria-hidden="true">
            <v-icon dark size="36">mdi-map-marker-path</v-icon>
          </span>
          <p class="login-brand__name">{{ $config.projectName }}</p>
        </div>

        <v-card class="login-card" :loading="$store.state.loading">
          <h1 class="login-card__title">تسجيل الدخول</h1>
          <p class="login-card__subtitle">أدخل بيانات حسابك للمتابعة</p>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="submit()"
            lazy-validation
          >
            <v-text-field
              v-model="form.identifier"
              :rules="[$rules.required()]"
              outlined
              label="البريد الالكتروني او اسم المستخدم"
              prepend-inner-icon="mdi-account-outline"
              autocomplete="username"
              required
            >
            </v-text-field>
            <v-text-field
              v-model="form.password"
              :rules="[$rules.required()]"
              label="كلمة المرور"
              type="password"
              prepend-inner-icon="mdi-lock-outline"
              autocomplete="current-password"
              outlined
              required
            >
            </v-text-field>
            <v-alert v-if="error" type="error" text dense role="alert">
              غير مخول بالدخول للنظام
            </v-alert>
            <v-btn
              block
              x-large
              depressed
              color="primary"
              :disabled="!valid"
              :loading="$store.state.loading"
              type="submit"
            >
              تسجيل الدخول
            </v-btn>
          </v-form>
        </v-card>
      </div>

      <svg
        class="login-waves"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        shape-rendering="auto"
        aria-hidden="true"
      >
        <defs>
          <path
            id="gentle-wave"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
          />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
          <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
          <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
        </g>
      </svg>
    </section>

    <footer class="login-footer">
      <p class="login-footer__text">
        Copyright © {{ new Date().getFullYear() }} -
        <a href="https://ft.iq" target="_blank" rel="noopener noreferrer">Future Of Technology</a>
        V1.0.0.5
      </p>
    </footer>
  </div>
</template>
<script>
import { encryptText } from "@/utils/crypto";
import { formatDateISO } from "@/utils/date";

export default {
  data() {
    return {
      form: {
        identifier: "",
        password: "",
      },
      valid: false,
      error: false,
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate();
      if (!this.valid) return;

      this.$store.commit("setLoading", true);
      this.$http
        .post("/login", {
          identifier: this.form.identifier,
          password: this.form.password,
        })
        .then((res) => {
          const users = res.status == 200 ? res.data : [];
          if (users.length > 0) {
            this.onLoginSucceeded(users[0]);
          } else {
            this.error = true;
          }
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
        });
    },
    onLoginSucceeded(user) {
      // NOTE: the credentials are kept in localStorage exactly as before (see the report).
      localStorage.setItem("username", this.form.identifier);
      localStorage.setItem("password", this.form.password);
      this.error = false;
      this.$store.state.userName = user.DisplayName;
      // The router guard accepts the session only for the day it was created.
      localStorage.setItem("accessTocken", encryptText(formatDateISO()));
      this.$store.commit("setUserData", user);
      // NOTE: "attahment" (sic) is not a registered route name; kept as it was.
      this.$router.push({ name: user.IsSalesmen == false ? "attahment" : "salesmen" });
    },
  },
};
</script>
